"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configuration = {
    onCaughtErrorHandlers: [],
};
/**
 * Configures mobx-safe.
 *
 * @param options   Options to add to the existing configuration.
 */
exports.configure = function (options) {
    if (options.clearOnCaughtErrorHandlers) {
        exports.configuration.onCaughtErrorHandlers.length = 0;
    }
    if (options.onCaughtError !== undefined) {
        exports.configuration.onCaughtErrorHandlers.push(options.onCaughtError);
    }
};
